export default {
  title: 'FRAUD DETECTION',
  items: {
    FraudDetectionEnabled: {
      label: 'Enable Fraud Detection',
      type: 'boolean'
    },
    FraudDaysCheck: {
      label: 'Fraud Time Window',
      type: 'integer',
      unit: 'days'
    },
    FraudCardUseCount: {
      label: 'No. of Times a Card Was Used',
      type: 'integer',
      unit: 'times'
    },
    FraudConsumerBooks: {
      label: 'No. of RSVPs Booked',
      type: 'integer',
      unit: 'times'
    },
    FraudStateCheck: {
      label: 'Verify Billing State',
      type: 'boolean'
    },
    FraudNotifyEmail: {
      label: 'Email to Notify',
      type: 'string',
      unit: 'email (comma-separated)'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/fraud-detection.js